import React from 'react';
import Button from '../../ui/Button';

const GhlFaq: React.FC = () => {
  const faqs = [
    {
      q: 'How do I import data into GoHighLevel?',
      a: 'Export your search results as a CSV from ProGeoData. In GHL, go to Contacts > Import > Upload CSV. Our export columns (First Name, Last Name, Email, Phone, Address, City, State, ZIP) map directly to GHL contact fields. No cleanup needed.',
    },
    {
      q: 'What professions do you have data for?',
      a: 'Over 50 licensed professions including dentists, plumbers, electricians, HVAC techs, real estate agents, insurance producers, contractors, attorneys, cosmetologists, nurses, and many more. If a state licenses it, we probably have it.',
    },
    {
      q: 'How fresh is the data?',
      a: 'We sync with official state licensing boards daily. When you search and export today, you are getting current data. License statuses, contact info, and addresses are continuously updated.',
    },
    {
      q: 'Can I automate imports to GHL via API?',
      a: 'Yes. On our Growth plan and above, you get full API access. You can build a webhook or Zapier integration that pulls new records from ProGeoData and pushes them into GHL automatically. Or use our CSV export for manual batch imports.',
    },
    {
      q: 'What does a "credit" get me?',
      a: 'One credit equals one record viewed or exported. A search costs 3 credits. Bulk exports cost 2 credits per 100 records. So with 5,000 credits on the Starter plan, you can export roughly 250,000 records per month or run 1,600+ searches.',
    },
    {
      q: 'What states do you cover?',
      a: 'Coverage is expanding regularly. Check /api/sources for the most current list of available states and professions. We are continuously adding new states and license types.',
    },
    {
      q: 'Is there a free trial?',
      a: 'Yes. Sign up and get a limited number of free searches to verify data quality before committing. No credit card required to explore.',
    },
    {
      q: 'How is this different from buying lists?',
      a: 'List brokers sell you a static file that was compiled months ago. We give you a live search engine backed by official state licensing data. You search when you need data, export exactly what you need, and know it is current.',
    },
  ];

  return (
    <section id="faq" className="py-24 bg-slate-900 border-t border-slate-800">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.q,
            "acceptedAnswer": { "@type": "Answer", "text": faq.a }
          }))
        }) }}
      />
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-white text-center mb-12">GHL Marketer FAQ</h2>

        <div className="space-y-8">
          {faqs.map((faq, i) => (
            <div key={i}>
              <h4 className="text-lg font-bold text-white mb-2">{faq.q}</h4>
              <p className="text-slate-400">{faq.a}</p>
            </div>
          ))}
        </div>

        {/* FINAL CTA */}
        <div className="mt-24 text-center bg-gradient-to-br from-emerald-950/50 to-slate-900 rounded-3xl p-12 border border-emerald-500/20">
          <h2 className="text-3xl font-bold text-white mb-4">Ready to Fill Your GHL Pipeline?</h2>
          <p className="text-lg text-slate-400 mb-8 max-w-xl mx-auto">
            Stop scraping. Stop buying stale lists. Get verified professional license data
            exported directly into GHL format, starting at $99/mo.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button size="lg" className="bg-emerald-600 hover:bg-emerald-500" onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}>
              Start Your Free Trial
            </Button>
            <Button variant="ghost" size="lg" className="text-slate-300" onClick={() => window.location.href = '/docs'}>
              View API Docs
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GhlFaq;
